module.exports = __webpack_public_path__ + "static/img/life.b455e4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/life.png
// module id = 48Nh
// module chunks = 1